import locales from "./locales";
export default locales;
